import { useEffect } from 'react';

import {
  selectIsAssetFetched,
  selectIsAssetFetching,
} from '../modules/fetching';
import { selectAssetById } from '../modules/assets';
import { fetchSvpAssetById } from '../modules/assets/actions';
import { useAppDispatch, useAppSelector } from '../modules/hooks';

import type { SvpAsset } from '@vgtv/api-client/lib/svp_asset';
import type { Vendor } from '../types';

function useSvpAssetFetch(assetId: SvpAsset['id'], vendor: Vendor) {
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (assetId) {
      dispatch(fetchSvpAssetById({ assetId, vendor }));
    }
  }, [assetId, vendor, dispatch]);

  const asset = useAppSelector((state) =>
    selectAssetById(state, vendor, assetId)
  );

  const isFetching = useAppSelector((state) =>
    selectIsAssetFetching(state, assetId, vendor)
  );

  const isFetched = useAppSelector((state) =>
    selectIsAssetFetched(state, assetId, vendor)
  );

  return { asset, isFetching, isFetched };
}

export { useSvpAssetFetch };
